import { createApi } from '@reduxjs/toolkit/query/react';
import { GraphQLClient } from 'graphql-request';
import { post } from '../Services/ApiClient';

export const client = new GraphQLClient('/graphql');

function graphqlRequestBaseQuery({ uri }: any) {
	return async ({ document, variables }: any) => {
		try {
			const { data } = await post(uri, { query: document, variables });

			if (data.errors) {
				return { error: { errors: data.errors } };
			}

			return data;
		} catch (e) {
			return e;
		}
	};
}

export const api = createApi({
	baseQuery: graphqlRequestBaseQuery({
		uri: '/graphql',
	}),
	endpoints: () => ({}),
});
